import React, { useState, useEffect } from 'react'
import { LeftBox, MainBox, RightBox } from './styles'
import { Box, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom';
import { ClassesStudentDashboard } from './Sections/Classes/classesStudentDashboard';
import { PurchaseHistory } from './Sections/PurchaseHistory/purchaseHistory';
import SectionNotFound from '../Common/Error404/sectionNotFound';
import { studentDashboardSx as styles } from './styles.js';

export const StudentDashboard = () => {
    const location = useLocation()
    const [tab, setTab] = useState("classes");
    const handleTabChange = (newTab) => {
        if (tab !== newTab) {
            setTab(newTab);
            window.location.hash = newTab;
        }
    }
    useEffect(() => {
        const hash = location.hash.substring(1);
        if (hash) {
            setTab(hash);
        }else {
            // If no hash, set default to courses and update URL
            setTab('classes');
            window.location.hash = 'classes';
        }
    }, [location.hash]);
    return (
        <>
            <MainBox sx={styles.mainBox}>
                <Box sx={styles.leftBoxWrapper}>
                    <LeftBox>
                        <Typography variant="h6" color={tab === 'classes' && "primary"} sx={styles.tabTypography} onClick={() => handleTabChange('classes')}>Classes</Typography>
                        <Typography variant="h6" color={tab === 'history' && "primary"} sx={styles.tabTypography} onClick={() => handleTabChange('history')}>Purchase History</Typography>
                    </LeftBox>
                </Box>
                <RightBox sx={styles.rightBox}>
                    {tab === 'classes' ? (
                       <ClassesStudentDashboard/>
                    ) : tab === 'history' ? (
                       <PurchaseHistory/>
                    ) : <SectionNotFound tab={tab}/>}
                </RightBox>
            </MainBox>
        </>

    )
}
